import { SampleStatusCard } from '@design-system/Cards/SampleStatusCard';
import { NavBar } from '@design-system/NavBar';
import { Skeleton } from '@design-system/Skeleton';
import { useGetSampleDetailsQuery } from '@viome/viome-base/src/usecase/Misc/MiscQuery';
import { ErrorLoadingPage } from '@/components/screens/ErrorHandling/ErrorLoadingPage';

export const TrackSamplesStatusPage = () => {
  const { data: samples, isLoading, error } = useGetSampleDetailsQuery();

  if (error) {
    return <ErrorLoadingPage/>
  }

  return (
    <section className="page-container flex flex-col gap-12">
      <div className="flex flex-col gap-6 md:gap-12">
        <NavBar buttonLabel={<span className="max-md:hidden">Account</span>} />
        <h1 className="typography-h1 text-primary">Track Sample Status</h1>
      </div>
        <ul className="flex flex-col gap-4">
          {isLoading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <Skeleton key={index} className="w-full h-52" />
            ))
          ) : (
            samples?.map((sample) => (
              <li key={sample.sample_information.sample_id}>
                <SampleStatusCard sample={sample} />
              </li>
            ))
          )}
        </ul>
    </section>
  );
};